import React from 'react'

import BoraBora from '../assets/image1.jpg';
import BoraBora2 from '../assets/image2.webp';
import Maldives from '../assets/image3.jpg';
import Maldives2 from '../assets/image4.jpg';
import KeyWest from '../assets/image5.jpg';

const Destinations = ({mainRef}) => {
  return (
    <div className='max-w-[1240px] mx-auto py-16 px-4 text-center'>
        <h1 ref={mainRef}>Hidden Place</h1>
        <p className='py-4'>Bored of trips that are exposed to the public, can't enjoy holidays and refreshments, even special moments!</p>
        <div className='grid grid-rows-none md:grid-cols-5 py-4 gap-2 md:gap-4'>
            <img className='w-full h-full object-cover col-span-2 md:col-span-3 row-span-2 rounded-xl' src={BoraBora} alt="/" />
            <img className='w-full h-full object-cover rounded-xl' src={BoraBora2} alt="/" />
            <img className='w-full h-full object-cover rounded-xl' src={Maldives} alt="/" />
            <img className='w-full h-full object-cover rounded-xl' src={Maldives2} alt="/" />
            <img className='w-full h-full object-cover rounded-xl' src={KeyWest} alt="/" />
        </div>
    </div>
  )
} 

export default Destinations